import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; // Importante para que funcionen los avisos
import Login from './components/Login';
import Dashboard from './components/Dashboard';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  // Si no hay token, redirige al login
  return token ? children : <Navigate to="/" />;
};

function App() {
  return (
    <Router>
      {/* 
        Colocamos ToastContainer aquí para que esté disponible en toda la app.
        Esto permite que los mensajes de "¡Actualizado con éxito!" se vean 
        aunque cambies de página.
      */}
      <ToastContainer 
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover 
        theme="colored"
      />

      <Routes>
        {/* Ruta Pública: Login */}
        <Route path="/" element={<Login />} />

        {/* Ruta Privada: Dashboard y el resto del sistema */}
        <Route
          path="/Dashboard/*" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Redirección por defecto si la ruta no existe */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;